import { v4 as uuid } from "uuid";

export const trumpCardObj = [
  {
    id: uuid(),
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/trump-cards/fast-delivery.png",
    alt: "fast-delivery",
    title: "Fast Delivery",
  },

  {
    id: uuid(),
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/trump-cards/geniune-products.png",
    alt: "geniune-products",
    title: "100 Geniune Products",
  },

  {
    id: uuid(),
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/trump-cards/easy-return.png",
    alt: "easy-return",
    title: "30 days easy return",
  },
];
